import clsx from 'clsx';

import {
  Espn,
  On3,
  On3Industry,
  On3Recruit,
  Rivals,
  TwoFourSeven,
} from '../Svg';
import { RivalsIndustry } from '../Svg/Service/RivalsIndustry';
import styles from './ServiceLogo.module.scss';

export type ServiceType =
  | 'espn'
  | '247'
  | 'twofourseven'
  | 'rivals'
  | 'on3'
  | 'recruits'
  | 'industry'
  | 'on3industry';
interface ServiceLogoProps {
  type: ServiceType;
  className?: string;
  [key: string]: any;
}

export const ServiceLogo = ({
  type,
  className,
  ...props
}: ServiceLogoProps) => {
  type = type.toLowerCase() as ServiceType;
  const logos = {
    espn: Espn,
    '247': TwoFourSeven,
    twofourseven: TwoFourSeven,
    rivals: Rivals,
    on3: On3,
    industry: RivalsIndustry,
    recruits: On3Recruit,
    on3industry: On3Industry,
  };

  const Logo = logos[type];

  if (!Logo) {
    return null;
  }

  return (
    <Logo
      className={
        className ??
        clsx(styles.base, {
          [styles.industry]: type.includes('industry') || type === 'on3',
        })
      }
      data-ui="service-logo"
      {...props}
    />
  );
};
